module.exports = __webpack_public_path__ + "img/arte-destaques-smart-home.0d520cd2.jpg";